import {
  GetLookupCompanyData,
  GetLookupCityAddress,
  GetPlaceDetails,
} from "@/server-types";
import { get } from "../request-helpers";
import { useCustomMutation } from "../custom-mutation";
import { useCustomQuery } from "../custom-query";

export const useGetLookupCompanyData = () => {
  return useCustomMutation({
    mutationKey: ["companyDataByTaxNumber"],
    mutationFn: (taxNumber: string) =>
      get<GetLookupCompanyData>(`/external/company-data`, {
        provider: "pirs",
        taxNumber,
      }),
    displayNotification: true,
  });
};

export const useGetLookupCityAddress = (
  query: GetLookupCityAddress["query"],
  enabled?: boolean,
) => {
  return useCustomQuery({
    queryKey: ["useGetLookupCityAddress", query],
    queryFn: () =>
      get<GetLookupCityAddress>("/external/geo/city/address", query),
    enabled:
      enabled ??
      Boolean(
        (query.searchQuery?.trim().length ?? 0) >= 3 &&
          (query.sessionToken?.length ?? 0) > 0,
      ),
  });
};

export const useGetPlaceDetails = () => {
  return useCustomMutation({
    mutationKey: ["useGetPlaceDetails"],
    mutationFn: (query: GetPlaceDetails["query"]) =>
      get<GetPlaceDetails>("/external/geo/city/place", query),
  });
};
